import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { LocatiiComponent } from './locatii.component';
import { AddLocatiiComponent } from './add-locatii/add-locatii.component';
import { EditLocatiiComponent } from './edit-locatii/edit-locatii.component';

@NgModule({
    declarations: [
        LocatiiComponent,
        AddLocatiiComponent,
        EditLocatiiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [LocatiiComponent],
})
export class LocatiiModule { }
